import Image from "next/image";

export function HeroImageBanner({ images }: { images?: string[] }) {
    const displayImages = (images || []).filter(img => img).map(img => ({ src: img, alt: 'Banner' }));

    if (displayImages.length === 0) return null;

    return (
        <div
            className="
            relative
            w-full
            bg-white
            "
        >
            <div
                className="
                mx-auto
                max-w-auto
                px-4
                sm:px-6
                py-2
                tsm-350:py-4
                sm:py-4
                lg:py-4
                lg:px-8
                xl:py-8
                "
            >
                <div
                    className="
                    flex
                    flex-wrap
                    justify-center
                    items-center
                    gap-2
                    sm:gap-3
                    lg:gap-4
                    xl:gap-6
                    "
                >
                    {displayImages.map((image, index) => (
                        <div
                            key={index}
                            className="
                            relative
                            w-[90px]
                            tsm-350:w-[100px]
                            sm:w-[150px]
                            lg:w-[180px]
                            xl:w-[230px]
                            h-[90px]
                            tsm-350:h-[100px]
                            sm:h-[150px]
                            lg:h-[180px]
                            xl:h-[230px]
                            overflow-hidden
                            "
                        >
                            <Image
                                src={image.src}
                                alt={image.alt}
                                fill
                                unoptimized
                                className="object-contain"
                                sizes="(max-width: 350px) 100px, (max-width: 639px) 150px, (max-width: 1023px) 180px, 230px"
                                priority
                                decoding="async"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

